import React from 'react';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { AddVenueBlockModalMessages as messages } from './Appointments.messages';

export default function AppointmentAddVenueBlockModal() {
  return (
    <Confirm
      title={<Message message={messages.title} />}
      acceptNode={<Message message={messages.accept} />}
      cancelNode={<Message message={messages.cancel} />}>
      <Message message={messages.description} />
    </Confirm>
  );
}
